export interface FeatureConfig {
  key: string;
  name: string;
  description: string;
  path: string;
  groupId: string;
  /** Optional elevated group that also grants access to the feature (admin implies member). */
  adminGroupId?: string;
}

export const FEATURE_GROUPS = {
  caap:     process.env.REACT_APP_CAAP_GROUP_ID || '',
  deficits: process.env.REACT_APP_DEFICITS_GROUP_ID || '',
  communication: process.env.REACT_APP_CUSTOMERCARE_GROUP_ID || '',
} as const;

export const COMMUNICATION_ADMIN_GROUP_ID = process.env.REACT_APP_CUSTOMERCARE_ADMIN_GROUP_ID || '';

export const FEATURE_CONFIG: FeatureConfig[] = [
  {
    key: 'caap',
    name: 'Collections Assignment',
    description: 'Automated collections agency assignment process (CAAP).',
    path: '/caap',
    groupId: FEATURE_GROUPS.caap,
  },
  {
    key: 'deficits',
    name: 'Deficits',
    description: 'Deficit management — coming soon.',
    path: '/deficits',
    groupId: FEATURE_GROUPS.deficits,
  },
  {
    key: 'communication',
    name: 'Communication',
    description: 'Communication call log — review and annotate your calls.',
    path: '/communication',
    groupId: FEATURE_GROUPS.communication,
    adminGroupId: COMMUNICATION_ADMIN_GROUP_ID,
  },
];

/**
 * Whether the user's group claims grant access to a feature. Access is granted by
 * the feature's member group OR its elevated admin group (admin implies member).
 */
export function canAccessFeature(feature: FeatureConfig, groups: string[]): boolean {
  if (feature.groupId && groups.includes(feature.groupId)) return true;
  if (feature.adminGroupId && groups.includes(feature.adminGroupId)) return true;
  return false;
}
